module.exports = __webpack_public_path__ + "img/47.7a594b45.svg";